import { useHistory } from "react-router-dom";
import type { GetQuotationrequestRSDef } from "../../../api/quotation/types";
import { brand } from "../../../context";
import { generateQuotationChatRoomCode } from "./api";
import { StatusTag, ViewOfferButton, ViewQuotationChatButton } from "./components";

type QuotationRequestMobileTableProps = {
  quotations: GetQuotationrequestRSDef[];
  hasChatRoomMapping: Record<string, boolean>;
  unreadCountsByQuotationReference: Record<string, number>;
};

export function QuotationRequestMobileTable({
  quotations,
  hasChatRoomMapping,
  unreadCountsByQuotationReference,
}: QuotationRequestMobileTableProps) {
  return (
    <table className="Table Quotations__body__mobiletable" data-brand={brand}>
      <thead>
        <tr>
          <th className="text-left!">Reference</th>
          <th className="text-left!">Title</th>
          <th className="text-left!">Status</th>
          <th className="text-left!">Actions</th>
        </tr>
      </thead>
      <tbody>
        {quotations.map((q, idx) => (
          <QuotationMobileTableRow
            key={`${idx}-${q.reference}`}
            quotation={q}
            hasChatRoomMapping={hasChatRoomMapping}
            unreadCount={unreadCountsByQuotationReference[q.reference] || 0}
          />
        ))}
      </tbody>
    </table>
  );
}

type QuotationMobileTableRowProps = {
  quotation: GetQuotationrequestRSDef;
  hasChatRoomMapping: Record<string, boolean>;
  unreadCount: number;
};

function QuotationMobileTableRow({
  quotation,
  hasChatRoomMapping,
  unreadCount,
}: QuotationMobileTableRowProps) {
  const history = useHistory();
  return (
    <tr className="odd:bg-gray-100">
      <td className="text-xs text-left!">{quotation?.reference}</td>
      <td className="text-xs text-left!">{quotation?.title || "N/A"}</td>
      <td className="text-xs text-left!">
        <StatusTag
          offerStatus={quotation.offer_status}
          status={quotation.status}
          statusDisplay={quotation.status_display}
        />
      </td>
      <td className="text-xs text-left!">
        <div className="grid gap-1">
          {quotation.chat_session_uid && (
            <ViewQuotationChatButton chatSessionUid={quotation.chat_session_uid} />
          )}
          {!!quotation?.offer_sent_date && quotation.offer_reference && (
            <ViewOfferButton offerReference={quotation.offer_reference} />
          )}
          {hasChatRoomMapping[quotation.reference] && (
            <button
              type="button"
              className="Button text-xs! p-1! relative"
              data-brand={brand}
              onClick={() => {
                history.push(
                  `/quotation-chat?room_code=${generateQuotationChatRoomCode(quotation.reference)}&reference=${quotation.reference}`,
                );
              }}
            >
              Chat
              {unreadCount > 0 && (
                <span className="absolute -right-2 -top-1 bg-red-500 text-white rounded-full min-w-[18px] h-[18px] flex items-center justify-center text-[11px] font-bold px-1 leading-none shadow-md">
                  {unreadCount > 99 ? "99+" : unreadCount}
                </span>
              )}
            </button>
          )}
        </div>
      </td>
    </tr>
  );
}
